import { Minus, Plus } from "lucide-react";

// Slider + −/+ for camera zoom; hidden when the track exposes no zoom range.
export function ScannerZoomControl({ zoom, onChange, label = "Zoom", testId = "scanner-zoom", className = "" }) {
  if (!zoom || !(zoom.max > zoom.min)) return null;
  const step = zoom.step || 0.1;
  const value = zoom.value ?? zoom.min;
  const clamp = (v) => Math.min(zoom.max, Math.max(zoom.min, v));
  const bump = step * 3;
  const stop = (e) => e.stopPropagation();
  return (
    <div
      className={`flex items-center gap-1 rounded-full bg-slate-900/65 backdrop-blur text-white shadow-lg select-none pr-3 ${className}`}
      data-testid={testId}
      aria-label={label}
      onClick={stop}
      onTouchStart={stop}
    >
      <button
        type="button"
        onClick={() => onChange(clamp(value - bump))}
        disabled={value <= zoom.min + 1e-3}
        data-testid={`${testId}-out`}
        className="h-11 w-11 shrink-0 rounded-full flex items-center justify-center active:scale-95 transition disabled:opacity-40"
        aria-label="zoom out"
      >
        <Minus className="h-5 w-5" />
      </button>
      <input
        type="range"
        min={zoom.min}
        max={zoom.max}
        step={step}
        value={value}
        onChange={(e) => onChange(clamp(parseFloat(e.target.value)))}
        data-testid={`${testId}-slider`}
        aria-label={label}
        className="flex-1 min-w-[72px] h-11 cursor-pointer accent-amber-400"
      />
      <span className="min-w-[2.8rem] text-center text-sm font-semibold tabular-nums" data-testid={`${testId}-value`}>
        {(value || 1).toFixed(step < 0.5 ? 1 : 0)}×
      </span>
      <button
        type="button"
        onClick={() => onChange(clamp(value + bump))}
        disabled={value >= zoom.max - 1e-3}
        data-testid={`${testId}-in`}
        className="h-11 w-11 shrink-0 rounded-full flex items-center justify-center active:scale-95 transition disabled:opacity-40"
        aria-label="zoom in"
      >
        <Plus className="h-5 w-5" />
      </button>
    </div>
  );
}

export default ScannerZoomControl;
